import { useInfiniteRoles } from '@/models/role';
import useDebouncedState from '@/utils/useDebouncedState';

const ROLES_PER_PAGE = 20;

export const useRoleFilterState = () => {
  const [search, debouncedSearch, setSearch] = useDebouncedState<string>('', 300);

  const { data: initialData } = useInfiniteRoles({
    limit: ROLES_PER_PAGE,
  });
  const { data, fetchNextPage, isLoading } = useInfiniteRoles({
    limit: ROLES_PER_PAGE,
    search: debouncedSearch || undefined,
  });

  const roles = data?.pages.flatMap((page) => page.roles) ?? [];
  const count = initialData?.pages[0]?.meta.count || 0;

  return {
    search,
    setSearch,
    fetchNextPage,
    isLoading,
    roles,
    count,
  };
};
